/*!
 * Copyright (C) Octillion Media LLC 2019
 * All Rights Reserved.
 */
import store from '@/state/store'
import { loadAgGrid } from '@/plugins/agGrid';
import { isLiveAdmin } from '@/helpers/util';



export default [
  {
    path: "/no-permission",
    name: "no-permission",
    component: () => import("../views/utility/no-permission"),
  },
  // Temporarily hide this route for now
  {
    path: "/update-password",
    name: "update_password",
    meta: {
      permission: "users/profile",
      authRequired: false,
      title: "Change Password",
    },
    component: () => import("../views/account/update-password"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "advertiser" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/recoverpwd",
    name: "Recovery Password",
    component: () => import("../views/account/recover-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/utility/404"),
  },
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: false,
      title: "Manage Dashboard",
      permission: "dashboard",
    },
    component: () => import("../views/dashboard/default"),
  },
  {
    path: "/campaigns/sports",
    name: "create_sport_campaign",
    meta: {
      authRequired: false,
      permission: "sports",
      title: "Sports Campaign",
    },
    component: () => import("../views/campaign/sportsLaunch"),
  },
  {
    path: "/campaigns/sport/:campaign_id",
    name: "edit_sport_campaign",
    meta: {
      authRequired: false,
      permission: "sports",
      title: "Edit Sports Campaign",
    },
    component: () => import("../views/campaign/sportsLaunch"),
  },
  {
    path: "/creatives",
    name: "creatives",
    meta: {
      authRequired: false,
      permission: "creatives",
      title: "Creatives",
    },
    beforeEnter: async (to, from, next) => {
      await loadAgGrid();
      next();
    },
    component: () => import("../views/creatives/list"),
  },

  {
    path: "/advertisers",
    name: "advertisers",
    meta: {
      authRequired: false,
      permission: "advertisers",
      title: "Advertisers",
    },
    beforeEnter: async (to, from, next) => {
      await loadAgGrid();
      next();
    },
    component: () => import("../views/advertisers/list"),
  },

  {
    path: "/campaigns/live-events",
    name: "create_event_campaign",
    meta: {
      authRequired: false,
      permission: "events",
      title: "Live Events Campaign",
    },
    component: () => import("../views/campaign/LiveEventsLaunch"),
  },
  {
    path: "/campaigns",
    name: "list_campaign",
    meta: {
      authRequired: false,
      permission: "campaign",
      title: "Campaign Lists",
    },
    component: () => import("../views/campaign/list"),
  },
  {
    path: "/downloads",
    name: "downloads",
    meta: {
      permission: "dashboard",
      authRequired: false,
      title: "Downloads Dashboard",
    },
    component: () => import("../views/dashboard/downloads"),
  },
  {
    path: '/games',
    name: 'games',
    meta: {
      authRequired: false,
      permission: 'games',
      title: 'Games',
    },
    component: () => import('../views/games/games'),
    beforeEnter: (to, from, next) => {
      if (!isLiveAdmin()) {
        next('/'); // or redirect to /403
      } else {
        next();
      }
    },
  },
];
